import React from 'react';
import { useRouter } from 'next/router';
import Icon from 'react-icons-kit';
import { androidDone } from 'react-icons-kit/ionicons/androidDone';
import { ADD_POST, SEARCH_PAGE } from '@core/ui/navigation/constant';
import Text from 'reusecore/src/elements/Text';
import Button from 'reusecore/src/elements/Button';
import { plusRound } from 'react-icons-kit/ionicons/plusRound';
import SuccessModalWrapper, { IconWrapper, ButtonWrapper } from './style';
import { useTranslation } from 'next-i18next';
import { slugify } from '../../../helpers/urlHandler';

const PublishModal = ({
  data: { adsTitle, sid, title, message, category, draft },
}) => {
  const router = useRouter();
  const { t } = useTranslation();

  const { locale } = router;

  return (
    <SuccessModalWrapper>
      <IconWrapper>
        <Icon icon={androidDone} size={28} />
      </IconWrapper>

      <Text
        content={title}
        as="span"
        fontSize={21}
        fontWeight={700}
        color="#333333"
        mb={15}
      />

      <Text
        content={message}
        as="span"
        fontSize={16}
        fontWeight={400}
        color="#8C8C8C"
        style={{ textAlign: 'center' }}
      />
      <ButtonWrapper>
        {/* <Link href={`/${ADD_POST}/new`}>
          <a>new</a>
        </Link> */}
        <Button
          title={t('publishView.title.create')}
          onClick={() => {
            // force reload page to avoid issue
            let localePath = '';
            if (locale !== process.env.LOCALE) {
              localePath = '/' + locale;
            }
            const addPath = (draft === true) ? 'partners/create-draft' : `${ADD_POST}/new`;
            window.location.href = `${localePath}/${addPath}`;
          }}
          icon={<Icon icon={plusRound} size={20} color="#595959" />}
          iconPosition="left"
          bg="transparent"
          color="#00BCD4"
          border="1px solid #00BCD4"
          className={'secondary'}
          style={{
            width: '100%',
            marginRight: 20,
          }}
        />

        <Button
          title={t('chat.see')}
          className={'primary'}
          onClick={() => {
            router.push({
              pathname: `/${SEARCH_PAGE}/[category]/[slug]`,
              query: {
                category: slugify(category),
                slug: slugify(adsTitle) + '-' + sid,
              },
            });
          }}
          style={{
            width: '100%',
          }}
        />

        {/* <Link href={`/${SINGLE_POST_PAGE}/${slug}`}>
          <a>view</a>
        </Link> */}
      </ButtonWrapper>
    </SuccessModalWrapper>
  );
};

export default PublishModal;
